module.exports = __webpack_public_path__ + "img/schedule-demo-th.912d9e1.png";